import React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HomePage.css";
import ConsultantLogo from "../../asseets/Business Consultant - iconSvg.co.png";
import EmployeeLogo from "../../asseets/Frame 1.png";

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center homepage-bg">
      <div className="logo-wrapper">
        <img src="/HRSetu-final-logo.svg" alt="Logo" className="page-logo" />
      </div>

      <div className="container">
        <h1 className="mb-3 fw-bold text-center text-white animate-heading mt-2">
          WELCOME TO O4S HR SETU
        </h1>
        <p className="text-center text-white mb-5 fs-5">
          Connecting professionals with opportunity
        </p>

        <div className="row justify-content-center g-4">
          {/* Employee Card */}
          <div className="col-12 col-sm-6 col-md-4">
            <div className="login-card">
              {/* Logo Top */}
              <div className="login-card-icon">
                <img src={EmployeeLogo} alt="Employee" className="icon-img" />
              </div>

              {/* Bottom Content */}
              <div className="login-card-bottom d-flex align-items-center justify-content-between">
                <div className="login-card-text">
                  <h6 className="fw-bold mb-1">FOR EMPLOYEE</h6>
                  <p className="mb-0 small">LOGIN TO YOUR EMPLOYEE DASHBOARD</p>
                </div>
                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => navigate("Employee-Login")}
                >
                  LOGIN
                </button>
              </div>
            </div>
          </div>

          {/* Consultant Card */}
          {/* <div className="col-12 col-sm-6 col-md-5"> */}
          <div className="col-12 col-sm-6 col-md-4">
            <div className="login-card">
              {/* Logo Top */}
              <div className="login-card-icon">
                <img
                  src={ConsultantLogo}
                  alt="Consultant"
                  className="icon-img"
                />
              </div>

              {/* Bottom Content */}
              <div className="login-card-bottom d-flex align-items-center justify-content-between">
                <div className="login-card-text">
                  <h6 className="fw-bold mb-1">FOR CONSULTANT</h6>
                  <p className="mb-0 small text-muted">
                    LOGIN TO YOUR CONSULTANT DASHBOARD
                  </p>
                </div>
                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => navigate("/Consultant-Login")}
                >
                  LOGIN
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
